<template>
   <span v-html="invoiceDetail"></span>
</template>

<script>
import { NetsisApi } from '@/api/netsis'
export default {
    data(){
        return {
            invoiceDetail: null,
            customerCode: null,
            documentNumber: null,
        }
    },
    mounted(){
        this.getFaturaDetail()
    },
    methods:{
        getFaturaDetail(){
            this.customerCode = this.$route.params?.customerCode || null
            this.documentNumber = this.$route.params?.documentNumber || null
            NetsisApi.FaturaDetayIcerikFromNetsis(this.customerCode,this.documentNumber).then(res=>{
                if(res.data.Success){
                    this.invoiceDetail = res.data.Message
                }else{
                    this.$result(res)
                }
            })
        }
    }   
}


</script>

<style>

</style>
